import {
  space,
  tok,
  tokPx,
} from '@sunwebgroup/ui-components'
import { Button, Icon, Typography } from '@sunwebgroup/ui-components/uds'
import { identity } from 'ramda'
import { css, styled } from 'styled-components'
import { useIntl } from '@/intl'
import { BusInfo, RouteDate } from '@/scopes/prices/domain/transports/types'

const InfoItem = styled.div`
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-right: ${space('primitives_space_16')};
`

const InfoBlock = styled.div`
  margin-top: ${space('primitives_space_8')}!important;
  flex-wrap: wrap;

  ${Icon} {
    margin-right: ${space('primitives_space_4')};
  }
`
const ListItemContent = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`

const CardContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${space('primitives_space_8')} ${space('primitives_space_8')} ${space('primitives_space_12')} ${space('primitives_space_8')};
`
const FeaturesWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-top: ${space('primitives_space_8')};
    padding-top: ${space('primitives_space_12')};
    border-top: 2px solid ${tok('semantics_dividers_color')};
    width: 100%;
`

const ListItemRoot = styled.div<{ isSelected?: boolean }>`
  background-color: ${tok('semantics_views_background_color')};
  border: ${tokPx('semantics_dividers_tickness')} solid ${tok('semantics_dividers_color')};
  border-radius: ${tokPx('primitives_corner_radius_l')};
  cursor: pointer;
  &:first-child {
    margin-top: 0 !important;
  }
  &:nth-child(2) {
    margin-top: 0 !important;
  }
  ${({ isSelected }) => css`
    border: ${tokPx('semantics_dividers_tickness')} solid ${isSelected ? tok('primitives_color_selected_600') : tok('semantics_dividers_color')};
  `}
`
const PriceWrapper = styled.div<{ isSelected?: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${space('primitives_space_12')};
    line-height: 1.75;
  ${({ isSelected }) => css`
    background: ${isSelected ? tok('primitives_color_selected_500') : tok('primitives_color_neutral_50')};
    color: ${isSelected ? tok('primitives_color_neutral_0') : tok('primitives_color_neutral_800')};
  `}
`

interface BusCardProps extends BusInfo {
  date?: RouteDate
  cityName: string
  id: string
  isSelected: boolean
  setSelected?: ((val: string) => void) | undefined
  noActiveState?: boolean | undefined
  stationName: string
}

export function BusCard({
  id,
  cityName,
  date,
  averagePrice,
  isSelected,
  setSelected = identity,
  noActiveState,
  stationName,
}: BusCardProps) {
  const intl = useIntl()

  return (
    <ListItemRoot
      isSelected={isSelected && !noActiveState}
      onClick={() => (!isSelected && !noActiveState ? setSelected(id) : null)}
    >
      <CardContent>
        <ListItemContent>
          <Typography variant="body-l-bold-tight">{cityName}</Typography>
          {date?.time
            ? (
                <Typography variant="body-m-regular-tight">{date.time}</Typography>
              )
            : (
                <Typography variant="body-m-regular-tight">&nbsp;</Typography>
              )}
          <FeaturesWrapper>
            <InfoBlock>
              <InfoItem>
                <Icon glyph="BusFront" size={18} />
                <Typography variant="body-s-regular-tight">{stationName}</Typography>
              </InfoItem>
            </InfoBlock>
          </FeaturesWrapper>
        </ListItemContent>
      </CardContent>
      <PriceWrapper isSelected={isSelected && !noActiveState}>
        <div>
          <Typography variant="body-m-bold-tight">{intl.formatCurrency(averagePrice, { showSign: true })}</Typography>
          <Typography variant="body-m-bold-tight">
            {' '}
            {intl.formatMessage({ id: 'prices_transport_selector_price-per-person_abbreviation' })}
          </Typography>
        </div>
        {!isSelected && (
          <Button size="S" variant="secondary">
            {intl.formatMessage({
              id: 'prices_transport_selector_bus-selector-select',
            })}
          </Button>
        )}
      </PriceWrapper>
    </ListItemRoot>
  )
}
